export { useShallowSelector } from '../../../hooks/useShallowSelector';

export const componentSelector = (state) => ({
  activeForgivenessId: state.activeIds.forgivenessId,
  country: state.country.country,
  loanForgivenessById: state.entities.loanForgiveness.byId,
  updateLoanForgiveness: state.updateLoanForgiveness,
});
